
var getters = {
['get'](state) {
        return state.userinfo
    },
}
export default getters
	


// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js